<template>
    <div v-if="existConfiguration">
        <div id="container-login-custom">
          <div class="circle-white"></div>
          <div class="internal-container-login-custom animated fadeInDown">
              <div class="login-custom">
                  <div class="login-custom-margin-mobile">
                      <img :src="companyInfo.company.logo" :alt="companyInfo.company.name"  class="img-responsive custom-logo"> 
                      <div>
                        <h4 class="text-color-welcome"><strong>¡Hola, Bienvenido a {{companyInfo.company.name}}!</strong></h4>
                        <p class="text-color-supplementary">{{ companyInfo.supplementary_text }}</p>
                      </div>              
                      <b-button v-if="companyInfo.provider.type === CONDITIONS.OIDC" @click="loginWithSupplier" class="btn full-width m-b btn-custom-colors" :disabled="loading">
                        <feather-icon v-if="loading" icon="LoaderIcon" class="spinner"/>
                        Iniciar sesión mediante {{companyInfo.provider.name}}
                      </b-button>
                      <form-login 
                        v-if="companyInfo.provider.type === CONDITIONS.ENVIAME" 
                        @authentication="authentication" 
                        ref="loginForm" 
                        :showContactLink="false"
                        formClass="form-login-custom"
                      />
                  </div>
              </div>
              <div class="support-text">
                <div>
                  <component
                    v-for="(info, index) in companyInfo.support_text"
                    :key="index"
                    :is="info.tag"
                    class="text-color-support"
                    :class="info.class"
                  >
                    {{ info.text }}
                  </component>
                </div>
              </div>
              <footer class="footer-login-custom">
                  <img :src="companyInfo.company.logo_enviame" width="183"  alt="">
                  <p class="text-color-footer">Powered by Envíame</p>
              </footer>       
          </div>   
      </div>
    </div>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Bugsnag from '@bugsnag/js'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LoginService from '../../login.service'
import FormLogin from './FormLogin.vue'

export default {
  components: {
    FormLogin
  },
  data () {
    return {
      companyInfo: {},
      existConfiguration: false,
      loginService: new LoginService(this),
      loggedUser: {},
      loading: false,
      CONDITIONS: Object.freeze({
        OIDC: 'oidc',
        CUSTOM: 'custom',
        ENVIAME: 'enviame'
      })
    }
  },
  mounted () {
    this.domainSettings()
  },
  methods: {
    domainSettings () {
      const domain = window.location.hostname
      const nameCompany = this.extractNameCompany(domain)
      const docRef = this.$root.$data.db.collection('domains').doc(nameCompany)
      docRef.onSnapshot((doc) => {
        if (doc.exists) {
          this.companyInfo = {...doc.data(), id: doc.id}
          this.applyStyles()
          this.existConfiguration = true
        } else {
          this.$alert(this.$t('msg-problema-cargar', {code: 'No existe personalización'}))
        } 
      }, (error) => {
        this.$alert(this.$t('msg-problema-cargar', {code: error}))
      })
    },
    extractNameCompany (domain) {
      const match = domain.match(/(?:^|\.)((?!www)[a-zA-Z0-9-]+)\.app\./)
      return match ? match[1] : null
    },
    applyStyles () {
      this.$nextTick(() => {
        setTimeout(() => {
          const { styles } = this.companyInfo || {}
          const elementsToStyle = [
            { selector: '.custom-logo', style: 'width', value: styles?.logo?.width || 'initial' },
            { selector: '.circle-white', style: 'backgroundColor', value: styles?.backgrounds?.circle || '#FFFFFF' },
            { selector: '#container-login-custom', style: 'background', value: styles?.backgrounds?.default || 'linear-gradient(90deg, #395494 0%, #31AEE4 100%)' },
            { selector: '.text-color-welcome', style: 'color', value: styles?.colors?.primary || '#000000' },
            { selector: '.text-color-supplementary', style: 'color', value: styles?.colors?.secondary || '#000000' },
            { selector: '.text-color-support, .text-color-footer', style: 'color', value: styles?.colors?.default || '#FFFFFF' }
          ]
          elementsToStyle.forEach(({ selector, style, value }) => {
            document.querySelectorAll(selector).forEach(element => {
              element.style[style] = value
            })
          })
          document.querySelectorAll('.btn-custom-colors').forEach(element => {
            element.setAttribute('style', `
            background: ${styles?.buttons?.background || 'linear-gradient(90deg,#f49143 -21.52%,#f4bb43 104.43%)'} !important;
            color: ${styles?.buttons?.color || '#FFFFFF'} !important
            `)
          })
        }, 100)
      })
    },
    async loginWithSupplier() {
      this.loading = true
      const provider = new firebase.auth.OAuthProvider(this.companyInfo.provider.id)
      try {
        const result = await firebase.auth().signInWithPopup(provider)      
        this.$root.$data.auth.setPersistence(this.$root.$data.fb.auth.Auth.Persistence.LOCAL)
        this.loggedUser = result.user
        this.createOrUpdateUser(result)
      } catch (error) {
        this.handleAuthError(error)
      }
    },
    handleAuthError (error) {
      let message = error.message
      if (error.code && ['auth/popup-closed-by-user', 'auth/cancelled-popup-request'].includes(error.code)) {
        message = 'El inicio de sesión fue cancelado por el usuario'
      }
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Error',
          icon: 'WarningIcon',
          variant: 'danger',
          text: message
        }
      })
      this.loading = false
    },
    async createOrUpdateUser (result) {
      const token = await this.loggedUser.getIdToken()
      const params = { token }
      const queryParams = {
        madagascar_uid: result.user.uid,
        first_name: result.additionalUserInfo.profile.given_name,
        last_name: result.additionalUserInfo.profile.family_name,
        email: result.additionalUserInfo.profile.email,
        role: null,
        company_id: this.companyInfo.company.id,
        login_type: this.companyInfo.provider?.type 
      }
      const config = {
        fullResponse: true
      }
      const headers = { Authorization: `Bearer ${token}` }
      this.loginService.callService('syncOauthUser', queryParams, params, config, headers)
        .then(resp => {
          // Es necesario ya que al crear, demora en replicarse el nuevo usuario creado a Dubai
          if (resp.status === 201) {
            this.$newSuccessSpinner('Espere un momento', 'Estamos creando su usuario en la plataforma')
            setTimeout(() => {
              this.m_closeAlertLoading()
              this.getUserInfoInFirestore(token)
            }, 10000) 
          }
          else {
            this.getUserInfoInFirestore(token)
          }
        })
        .catch(err => {
          let normalizedError = err
          if (!(err instanceof Error)) {
            normalizedError = new Error(typeof err === 'string' ? err : JSON.stringify(err))
          }
          console.error(normalizedError)
          this.savePermissionUpdateFailure(normalizedError)
          this.handleAuthError(normalizedError)
          this.loading = false
        })
    },
    getUserInfoInFirestore (token) {
      this.$store.dispatch('fetchUserData', {id: this.loggedUser.uid, token, from: 'login-okta'})
    },
    savePermissionUpdateFailure (err) {
      Bugsnag.notify(err, event => {
        event.addMetadata('updatePermissionsUserLogin', {
          message: 'Error al crear/actualizar los permisos del usuario al loguearse con Okta',
          errorMessage: err
        })
      })
    },
    // Copia de la logica actual de logueo
    // Estoy hay que revisar con back como haremos con los logins personalizados
    async authentication({ email, password }) {
      try {
        const auth = this.$root.$data.auth
        const fbAuth = this.$root.$data.fb.auth

        const data = await auth.signInWithEmailAndPassword(email, password)
        await auth.setPersistence(fbAuth.Auth.Persistence.LOCAL)

        this.loggedUser = data.user

        const token = await data.user.getIdToken()

        const params = { token }
        const headers = { Authorization: `Bearer ${token}` }

        try {
          await this.loginService.callService('updatePermissionUser', params, params, {}, headers)
        } catch (err) {
          // Reportar el error a Bugsnag
          Bugsnag.notify(err, event => {
            event.addMetadata('updatePermissionsUserLogin', {
              message: 'Error al actualizar los permisos del usuario al loguearse',
              errorMessage: err
            })
          })
        }

        this.$store.dispatch('fetchUserData', { id: this.loggedUser.uid, token, from: 'login', remember: this.status })
      } catch (err) {
        this.$refs.loginForm.setRecapchat()
        this.$refs.loginForm.setLoading(false)
        this.loading = false

        console.error(err)
        let message = err.message

        if (err.code && ['auth/wrong-password', 'auth/user-not-found'].includes(err.code)) {
          message = 'Correo o contraseña incorrectos'
        }

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'WarningIcon',
            variant: 'danger',
            text: message
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
    .circle-white {
      border-radius: 50%;
      position: absolute;
      overflow: hidden;
      z-index: 2;
      width: 100%;
      height: 200%;
      transform: translate(-50%, -25%)
    }
    #container-login-custom {
      position: relative;
      z-index: 1;
      overflow: hidden;
      min-height: 100vh;
    }
    .internal-container-login-custom {
      position: relative;
      z-index: 100 !important;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      height: 100vh;
    }
    .form-login-custom .input-group {
      align-items: stretch !important;
    }
    .login-custom h4 {
      margin: 5px 0;
    }
    .login-custom p {
      font-size: 15px;
      margin: 0 0 10px;
    }
    .login-custom, .support-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 4rem; 
    }
    .support-text {
      align-items: center;
      padding: 4rem 8rem;
    }
    .support-text h1, .support-text h3 {
      font-weight: 600;
      margin: 0;
    }
    .support-text h1 {
      font-size: 45px;
    }
    .login-custom .img-responsive{
      margin-bottom: 3rem;
    }
    .btn-custom-colors {
      border-radius: 10px;
      padding: 1.1rem 1.5rem;
      border: none;
      font-weight: 700;
      margin-top: 7rem;
      margin-bottom: 5rem;
    }
    .btn-custom-colors:hover {
      box-shadow: 0 8px 25px -8px #82868b;
    }
    .footer-login-custom {
      position: absolute;
      bottom: 0;
      right: 15px;
      font-weight: 400;
      font-size: 11px;
    }
    .footer-login-custom p {
      font-size: 15px;
    }
    @media (max-width: 870px) {
      .circle-white {
          border-radius: 50% / 13%;
          width: 200%;
          height: 100%;
          transform: translate(-25%, -30%);
      }
      .internal-container-login-custom {
          display: flex;
          flex-direction: column;
          height: inherit;
      }
      .login-custom {
          padding: 1rem;
          justify-content: flex-start;
          height: 50%;
      }
      .login-custom-margin-mobile {
          margin-top: 5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
      }
      .btn-custom-colors {
        margin-top: 3rem;
        margin-bottom: 0rem;
      }
      .support-text {
        padding: 2rem;
        margin-top: 15rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .support-text h1 {
        font-size: 25px;
      }
      .support-text h1, .support-text h3, .login-custom h4, .login-custom p {
        text-align: center;
      }
      .login-custom .img-responsive{
        width: 100px !important;
        margin-bottom: 1rem;
      }
      .footer-login-custom {
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: static;
      }
      .footer-login-custom img {
        width: 150px;
      }
      .footer-login-custom p {
        font-size: 13px;
      }
    }
</style>